"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchDocSortType = void 0;
/**
 * 搜索文档排序类型
 */
var SearchDocSortType;
(function (SearchDocSortType) {
    SearchDocSortType["RELEVANCE"] = "relevance";
    SearchDocSortType["LAST_EDITED_NEWEST"] = "last_edited_newest";
    SearchDocSortType["LAST_EDITED_OLDEST"] = "last_edited_oldest";
    SearchDocSortType["CREATED_NEWEST"] = "created_newest";
    SearchDocSortType["CREATED_OLDEST"] = "created_oldest";
})(SearchDocSortType = exports.SearchDocSortType || (exports.SearchDocSortType = {}));
